// extracted by mini-css-extract-plugin
module.exports = {"background":"tempstyles_background__C1D9y","card":"tempstyles_card__145XW","heading":"tempstyles_heading__ZTKE5","message":"tempstyles_message__FDTJi"};